import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@optools/components/ui/table';
import { SkyviewConfig } from '@optools/services/operator-gateway/types/generated/graphql';
import { Team } from '@optools/services/statsapi/types';
import { Earth } from 'lucide-react';

import { TeamConfigCard } from '../team-config-card';
import { SkyviewConfigSwitch } from './skyview-config-switch';

export interface SkyviewConfigCardProps {
  configs: SkyviewConfig[];
  team: Team | undefined;
  teamId: number;
}

export function SkyviewConfigCard({ configs, team, teamId }: SkyviewConfigCardProps) {
  return (
    <TeamConfigCard data-testid={`skyview-config-card-${teamId}`} team={team} teamId={team?.id}>
      <Table className="mt-2">
        <TableHeader>
          <TableRow>
            <TableHead className="flex items-center gap-1">
              <Earth className="size-4" />
              Language
            </TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {configs.map(({ enabled, language }) => (
            <TableRow key={language}>
              <TableCell className="w-full capitalize">{language}</TableCell>
              <TableCell className="flex justify-center">
                <SkyviewConfigSwitch enabled={enabled} language={language} teamId={teamId} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TeamConfigCard>
  );
}
